
class SEPACell extends UITableViewCell
{
    delegate:AccountingEntryDelegate = null;

    private referenceDateLabel:MUILabel = null;
    private conceptLabel:MUILabel = null;
    private amountLabel:MUILabel = null;
    private linkButton:MUIButton = null;

    awakeFromHTML(){
        this.referenceDateLabel = MUIOutlet(this, "reference-date-lbl", "MUILabel");
        this.conceptLabel = MUIOutlet(this, "concept-lbl", "MUILabel");
        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");
        this.linkButton = MUIOutlet(this, "cell-link-btn", "MUIButton");
        this.linkButton.setAction(this, this.linkAction);
    }    

    private _item:BankTransferBundleFile = null;
    set item(item:BankTransferBundleFile){
        this._item = item;
        this.referenceDateLabel.text = item.referenceDateString;
        this.conceptLabel.text = item.concept;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        this.amountLabel.text = ad.currencyFormatter.stringFromNumber( item.totalAmount );

        //this.linkButton.hidden = item.journalEntry != null;
        if (item.journalEntry != null) {
            MUICoreLayerAddStyle(this.referenceDateLabel.layer, "light");
            MUICoreLayerAddStyle(this.conceptLabel.layer, "light");
            MUICoreLayerAddStyle(this.amountLabel.layer, "light");            
        }
    }

    private linkAction() {
        this.delegate?.linkInstalmentsFromBankFile(this, this._item);
    }
}